import type { TranslateFn } from '../../types/common';

/**
 * The surfaces that can carry a held-for-review marker. These mirror the API's
 * moderated surfaces (Post, Comment, Chat) — no group, conversation or profile
 * response carries a moderation field, so they are deliberately absent.
 */
export type ModeratedContentType = 'post' | 'comment' | 'message';

/**
 * Explanatory copy for content the author can see but nobody else can.
 *
 * The create/update endpoints also return a `message`, but it is English-only
 * and the read endpoints never send it, so the copy is resolved from i18n
 * instead. That keeps the wording identical whether the hold was just reported
 * by a mutation or loaded back with a feed.
 */
export const moderationHoldMessage = (
  t: TranslateFn,
  contentType: ModeratedContentType,
): string => {
  switch (contentType) {
    case 'comment':
      return t('moderation.commentMessage');
    case 'message':
      return t('moderation.messageMessage');
    case 'post':
      return t('moderation.postMessage');
  }
};
